import type { ReactNode } from "react";
import { Fragment } from "react";
import { AssigneeDate } from "./AssigneeDate";
import AssigneeStatus from "./AssigneeStatus";

interface Props {
  children: ReactNode;
}

export const Assignee = (props: Props) => {
  const { children } = props;

  return <Fragment>{children}</Fragment>;
};

Assignee.Date = AssigneeDate;
Assignee.Status = AssigneeStatus;
